import { Divider } from '@mui/material';
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLine,
  IconMail,
  IconPhone,
} from '@tabler/icons-react';
import { Link } from 'react-router-dom';

const socialLinks = [
  {
    href: 'https://www.instagram.com/santtaiofficial/',
    label: 'Instagram',
    icon: IconBrandInstagram,
  },
  {
    href: 'https://www.facebook.com/santtaiOA',
    label: 'Facebook',
    icon: IconBrandFacebook,
  },
  {
    href: 'https://lin.ee/hrIH5m4',
    label: 'LINE',
    icon: IconBrandLine,
  },
  {
    href: 'mailto:hello@santtai.com',
    label: 'Email',
    icon: IconMail,
  },
] as const;

const Footer = () => {
  return (
    <footer className="mt-10 bg-santtai-900 px-4 pb-8 pt-10 sm:px-6 lg:mt-12 lg:px-12 lg:pb-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:mb-10 lg:grid-cols-3 lg:gap-12">
          <div className="flex flex-col">
            <span className="font-semibold text-neutral-50">
              Top destinations
            </span>
            <Link
              to="/destinations/thailand"
              className="mt-2 text-sm font-bold text-neutral-50 no-underline"
            >
              Thailand
            </Link>
            <Link
              to="/destinations/indonesia"
              className="mt-2 text-sm font-bold text-neutral-50 no-underline"
            >
              Indonesia
            </Link>
            <Link
              to="/destinations/micronesia"
              className="mt-2 text-sm font-bold text-neutral-50 no-underline"
            >
              Micronesia
            </Link>
            <Link
              to="/destinations/maldives"
              className="mt-2 text-sm font-bold text-neutral-50 no-underline"
            >
              Maldives
            </Link>
            <Link
              to="/destinations/mexico"
              className="mt-2 text-sm font-bold text-neutral-50 no-underline"
            >
              Mexico
            </Link>
          </div>
          <div className="hidden lg:block">
            <span className="font-semibold text-neutral-50">
              Explore dive sites
            </span>
            <div className="mt-2 grid grid-cols-2 gap-x-8 gap-y-2">
              <div className="flex flex-col">
                <span className="mt-2 text-sm text-neutral-50">Thailand</span>
                <Link
                  to="/routes/north-andaman"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  North Andaman
                </Link>
                <Link
                  to="/routes/south-andaman"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  South Andaman
                </Link>
                <Link
                  to="/routes/koh-tao"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  Koh Tao
                </Link>
              </div>
              <div className="flex flex-col">
                <span className="mt-2 text-sm text-neutral-50">Indonesia</span>
                <Link
                  to="/routes/bali"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  Bali - Sumbawa - West Flores
                </Link>
                <Link
                  to="/routes/komodo"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  Komodo
                </Link>
                <Link
                  to="/routes/raja-ampat"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  Ring of Fire - Raja Ampat
                </Link>
              </div>
              <div className="flex flex-col">
                <span className="mt-2 text-sm text-neutral-50">Maldives</span>
                <Link
                  to="/routes/central-atolls"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  Central Atolls
                </Link>
                <Link
                  to="/routes/southern-atolls"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  Southern Atolls
                </Link>
              </div>
              <div className="flex flex-col">
                <span className="mt-2 text-sm text-neutral-50">Micronesia</span>
                <Link
                  to="/routes/palau"
                  className="mt-2 pl-4 text-sm font-bold text-neutral-50 no-underline"
                >
                  Palau
                </Link>
              </div>
            </div>
          </div>
          <div>
            <span className="font-semibold text-neutral-50">Contact us</span>
            <div className="mt-3 flex">
              {socialLinks.map(({ href, label, icon: Icon }) => (
                <a
                  key={label}
                  href={href}
                  target={href.startsWith('mailto:') ? undefined : '_blank'}
                  rel={
                    href.startsWith('mailto:')
                      ? undefined
                      : 'noopener noreferrer'
                  }
                  aria-label={label}
                  className="mr-2 rounded-full bg-brand-secondary p-2 text-white"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
            <a
              href="tel:+66891308888"
              className="mt-4 flex items-center text-neutral-50 no-underline lg:mt-8"
            >
              <IconPhone size={16} />
              <span className="ml-1">(+66) 89 130 8888</span>
            </a>
          </div>
        </div>
        <div className="bg-neutral-50">
          <Divider />
        </div>
        <div className="mt-4 flex flex-col gap-3 text-sm text-neutral-50 lg:flex-row lg:items-center">
          <span className="lg:mr-12">Santtai©</span>
          <Link
            to="/privacypolicy"
            className="text-neutral-50 no-underline lg:mr-6"
          >
            Terms and conditions
          </Link>
          <Link to="/privacypolicy" className="text-neutral-50 no-underline">
            Privacy policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
